<script setup lang="ts">
// types
import type { StrapiHeaderMultipleMenu } from '@ts-strapi/interfaces'
// assets
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
// components
import { AppText } from '@UI/Typography/AppText'
import { AppIcon } from '@UI/Icons/AppIcon'
import { LinkBase } from '@UI/Links/LinkBase'

interface HeaderMultipleMenuProps {
  item: StrapiHeaderMultipleMenu
}

defineOptions({
  name: 'HeaderMultipleMenu',
})

defineProps<HeaderMultipleMenuProps>()
</script>

<template>
  <div class="header-multiple-menu">
    <section class="header-multiple-menu__grades">
      <AppText
        class="header-multiple-menu__heading"
        tag="h3"
        name="body3-medium"
        color="slate-900"
      >
        {{ item.subTitle }}
      </AppText>

      <div class="header-multiple-menu__columns">
        <div
          v-for="col in item.columns"
          :key="col.titleLink.url"
          class="header-multiple-menu__column"
        >
          <LinkBase
            :link="col.titleLink"
            class="header-multiple-menu__col-title"
          >
            <AppText
              tag="span"
              name="body4-medium"
              color="slate-500"
            >
              {{ col.titleLink.label }}
            </AppText>
          </LinkBase>

          <ul class="header-multiple-menu__links">
            <li
              v-for="link in col.links"
              :key="link.url"
            >
              <LinkBase :link="link">
                <AppText
                  tag="span"
                  name="body2"
                  color="slate-700"
                >
                  {{ link.label }}
                </AppText>
              </LinkBase>
            </li>
          </ul>
        </div>
      </div>

      <LinkBase
        v-if="item.seeAllLink"
        :link="item.seeAllLink"
        class="header-multiple-menu__see-all"
      >
        <AppText
          tag="span"
          name="body2-medium"
          color="indigo-500"
        >
          {{ item.seeAllLink.label }}
        </AppText>
        <AppIcon
          :icon="faArrowRight"
          size="medium"
          color="indigo-500"
        />
      </LinkBase>
    </section>

    <section class="header-multiple-menu__program">
      <AppText
        class="header-multiple-menu__heading"
        tag="h3"
        name="body3-medium"
        color="slate-900"
      >
        {{ item.programTitle }}
      </AppText>

      <ul class="header-multiple-menu__program-links">
        <li
          v-for="link in item.programLinks"
          :key="link.url"
        >
          <LinkBase :link="link">
            <AppText
              tag="span"
              name="body2"
              color="slate-700"
            >
              {{ link.label }}
            </AppText>
          </LinkBase>
        </li>
      </ul>
    </section>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderMultipleMenu.scss" />